export default __webpack_public_path__ + "84037dce20e74638acc5dfa6f9eb06fa.png";